import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { RewriteWithAI } from './RewriteWithAI';

interface PortalData {
  id: string;
  selectedText: string;
  savedRange: Range | null;
  popupPosition: { x: number; y: number };
  onRangeChange: (range: Range | null) => void;
  variant?: string;
  clearRange: () => void;
  textAlignment?: boolean;
  canUseMarkTag?: boolean;
}

const portalListeners: Set<(portal: PortalData | null) => void> = new Set();

export const setActivePortal = (portal: PortalData | null) => {
  portalListeners.forEach(listener => listener(portal));
};

const subscribeToPortal = (listener: (portal: PortalData | null) => void) => {
  portalListeners.add(listener);
  return () => {
    portalListeners.delete(listener);
  };
};

export const GlobalRewritePortal: React.FC = () => {
  const [portalData, setPortalData] = useState<PortalData | null>(null);

  useEffect(() => {
    return subscribeToPortal(setPortalData);
  }, []);

  if (!portalData) return null;

  if (portalData && portalData.variant == 'sub_heading') {
    return null;
  }

  return createPortal(
    <div
      data-rewrite-portal="true"
      onMouseDown={e => e.stopPropagation()}
      onMouseUp={e => e.stopPropagation()}
      onClick={e => e.stopPropagation()}
      style={{
        position: 'absolute',
        top: portalData.popupPosition.y,
        left: portalData.popupPosition.x,
        padding: '5px 10px',
        borderRadius: '4px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: '5px'
      }}
    >
      <RewriteWithAI
        id={portalData.id}
        selectedText={portalData.selectedText}
        savedRange={portalData.savedRange}
        onRangeChange={portalData.onRangeChange}
        variant={portalData.variant}
        clearRange={portalData.clearRange}
        textAlignment={portalData.textAlignment}
        canUseMarkTag={portalData.canUseMarkTag}
      />
    </div>,
    document.body
  );
};
